import { render, staticRenderFns } from "./moor-hello-world.vue?vue&type=template&id=53eb9832&"
import script from "./moor-hello-world.vue?vue&type=script&lang=js&"
export * from "./moor-hello-world.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.5.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "moor-hello-world.vue"
export default component.exports